import gql from 'graphql-tag';

export const CHECK_RELEASE_PAYMENT_STATUS = gql`
    mutation(
        $checkPaymentStatusInput: CheckPaymentStatusInput!
    ) {
        checkReleasePaymentStatus (
            checkReleasePaymentStatus: $checkPaymentStatusInput
        ) {
            response
            message
            status
            paidAmount
            paidAt
        }
    }
`;